(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/address.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/address.js');
"use strict";


const _React = React,
  useContext = _React.useContext,
  Fragment = _React.Fragment;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input,
  ZipCodeInput = _svs$ticket_partner$s.ZipCodeInput,
  AdressInput = _svs$ticket_partner$s.AdressInput,
  CityInput = _svs$ticket_partner$s.CityInput,
  ContactInput = _svs$ticket_partner$s.ContactInput,
  CountryDropdown = _svs$ticket_partner$s.CountryDropdown;
const countries = svs.ticket_partner.sharedComponents.input.constants.countries;
const _svs$ticket_partner$s2 = svs.ticket_partner.sharedComponents.input.constants.names,
  COUNTRYID = _svs$ticket_partner$s2.COUNTRYID,
  CONTACT = _svs$ticket_partner$s2.CONTACT,
  ZIP = _svs$ticket_partner$s2.ZIP,
  ADDRESS1 = _svs$ticket_partner$s2.ADDRESS1,
  CITY = _svs$ticket_partner$s2.CITY;
const UPDATE_ADDRESS = svs.ticket_partner.companyDetails.constants.actions.UPDATE_ADDRESS;
const mapHeader = svs.ticket_partner.companyDetails.utils.mapHeader;
const Address = _ref => {
  let adress = _ref.adress,
    _ref$disableOnEdit = _ref.disableOnEdit,
    disableOnEdit = _ref$disableOnEdit === void 0 ? false : _ref$disableOnEdit;
  const _useContext = useContext(svs.ticket_partner.CompanyDetailsContext),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  const edit = state.companyDetails.edit;
  const addressType = adress.addressType,
    contact = adress.contact,
    zip = adress.zip,
    countryId = adress.countryId,
    address1 = adress.address1,
    city = adress.city;
  const header = mapHeader(addressType.toLowerCase());
  const getCountryById = countryId => countries.find(_ref2 => {
    let id = _ref2.id;
    return countryId === id;
  }).name || '';
  const adressDetails = [contact, address1, zip, city, getCountryById(countryId)];
  const handleChange = e => {
    dispatch({
      type: UPDATE_ADDRESS,
      payload: {
        field: e.target.id,
        value: e.target.value,
        addressToUpdate: addressType
      }
    });
  };
  const handleDropdownChange = e => {
    dispatch({
      type: UPDATE_ADDRESS,
      payload: {
        field: COUNTRYID,
        value: parseInt(e.target.value, 10),
        addressToUpdate: addressType
      }
    });
  };
  return React.createElement(Fragment, null, React.createElement("h2", null, header), edit ? React.createElement(Fragment, null, React.createElement(ContactInput, {
    disabled: disableOnEdit,
    handleChange: handleChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(CONTACT),
    state: adress,
    stateField: CONTACT
  }), React.createElement(AdressInput, {
    disabled: disableOnEdit,
    handleChange: handleChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(ADDRESS1),
    state: adress
  }), React.createElement(ZipCodeInput, {
    disabled: disableOnEdit,
    handleChange: handleChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(ZIP),
    state: adress
  }), React.createElement(CityInput, {
    disabled: disableOnEdit,
    handleChange: handleChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(CITY),
    state: adress
  }), React.createElement(CountryDropdown, {
    disabled: disableOnEdit,
    handleDropDownChange: handleDropdownChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(COUNTRYID),
    state: adress
  })) : adressDetails.map((detail, i) => React.createElement("div", {
    key: _.uniqueId(i)
  }, ' ', detail, ' ')));
};
svs.ticket_partner.companyDetails.components.companyDetailsForm.components.Address = Address;

 })(window);